module.exports = __webpack_public_path__ + "img/态势管理-bg.a030d242.jpg";